import { useState } from "react";
import { useParams } from "react-router-dom";
import Seo from "../components/Seo";
import StatusBadge from "../components/StatusBadge";
import { api } from "../lib/api";

export default function OrderLookup() {
  const { lang = "en" } = useParams();
  const zh = lang === "zh";
  const [form, setForm] = useState({ order_no: "", email: "", phone: "" });
  const [order, setOrder] = useState<Record<string, any> | null>(null);
  const [error, setError] = useState("");
  async function lookup() {
    setError("");
    try { setOrder(await api("/api/order-lookup", { method: "POST", body: JSON.stringify(form) })); }
    catch (e) { setError(e instanceof Error ? e.message : "Lookup failed"); }
  }
  return (
    <>
      <Seo title={zh ? "订单查询" : "Order Lookup"} description="Check order, payment, and shipping status at SellerSupply Shop." />
      <section className="container-page py-10">
        <div className="grid gap-6 lg:grid-cols-[420px_1fr]">
          <div className="panel space-y-4 p-6">
            <h1 className="text-3xl font-black">{zh ? "订单查询" : "Order Lookup"}</h1>
            <input className="input" placeholder={zh ? "订单号" : "Order number"} value={form.order_no} onChange={(e) => setForm({ ...form, order_no: e.target.value })} />
            <input className="input" placeholder={zh ? "邮箱" : "Email"} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <input className="input" placeholder={zh ? "电话" : "Phone"} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
            <button className="btn-primary w-full" onClick={lookup}>{zh ? "查询订单" : "Check Order"}</button>
            {error ? <p className="text-sm font-bold text-red-600">{error}</p> : null}
          </div>
          <div className="panel p-6">
            {order ? (
              <div className="space-y-4">
                <h2 className="text-2xl font-black">{order.order_no}</h2>
                <div className="flex flex-wrap gap-3"><StatusBadge status={order.status} /><StatusBadge status={order.payment_status} /></div>
                <div className="grid gap-4 md:grid-cols-2">
                  <p><b>{zh ? "物流公司" : "Shipping company"}:</b> {order.shipping_company || "-"}</p>
                  <p><b>{zh ? "物流单号" : "Tracking number"}:</b> {order.tracking_number || "-"}</p>
                  <p><b>{zh ? "查询链接" : "Tracking URL"}:</b> {order.tracking_url ? <a className="text-[#C89B5C]" href={order.tracking_url}>{order.tracking_url}</a> : "-"}</p>
                  <p><b>{zh ? "订单金额" : "Total"}:</b> {order.currency} {order.total || order.total_amount}</p>
                </div>
              </div>
            ) : <p className="text-slate-500">{zh ? "输入订单号和邮箱或电话后查看订单状态。" : "Enter your order number and email or phone to view status."}</p>}
          </div>
        </div>
      </section>
    </>
  );
}
